import { render, staticRenderFns } from "./BlogPostDetail.vue?vue&type=template&id=5b5064b0&scoped=true&"
import script from "./BlogPostDetail.vue?vue&type=script&lang=js&"
export * from "./BlogPostDetail.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostDetail.vue?vue&type=style&index=0&id=5b5064b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5064b0",
  null
  
)

export default component.exports